// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coverage-stat-card[data-v-183e58e1]{border-radius:10px}.coverage-table[data-v-183e58e1]{border-radius:6px;border:1px solid rgba(0,0,0,.08)}", ""]);
// Exports
module.exports = exports;
